"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Address = _interopRequireDefault(require("./Address"));
var _DirectDebitDetails = _interopRequireDefault(require("./DirectDebitDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The DirectDebit model module.
 * @module model/DirectDebit
 * @version 3.0
 */
var DirectDebit = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>DirectDebit</code>.
   * @alias module:model/DirectDebit
   */
  function DirectDebit() {
    _classCallCheck(this, DirectDebit);
    DirectDebit.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(DirectDebit, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>DirectDebit</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DirectDebit} obj Optional instance to populate.
     * @return {module:model/DirectDebit} The populated <code>DirectDebit</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new DirectDebit();
        if (data.hasOwnProperty('paymentId')) {
          obj['paymentId'] = _ApiClient["default"].convertToType(data['paymentId'], 'Number');
        }
        if (data.hasOwnProperty('basketId')) {
          obj['basketId'] = _ApiClient["default"].convertToType(data['basketId'], 'Number');
        }
        if (data.hasOwnProperty('amount')) {
          obj['amount'] = _ApiClient["default"].convertToType(data['amount'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('gateway')) {
          obj['gateway'] = _ApiClient["default"].convertToType(data['gateway'], 'String');
        }
        if (data.hasOwnProperty('confirmedBasketHash')) {
          obj['confirmedBasketHash'] = _ApiClient["default"].convertToType(data['confirmedBasketHash'], 'String');
        }
        if (data.hasOwnProperty('directDebitDetails')) {
          obj['directDebitDetails'] = _DirectDebitDetails["default"].constructFromObject(data['directDebitDetails']);
        }
        if (data.hasOwnProperty('billingAddress')) {
          obj['billingAddress'] = _Address["default"].constructFromObject(data['billingAddress']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DirectDebit</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DirectDebit</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
        throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
      }
      // ensure the json data is a string
      if (data['confirmedBasketHash'] && !(typeof data['confirmedBasketHash'] === 'string' || data['confirmedBasketHash'] instanceof String)) {
        throw new Error("Expected the field `confirmedBasketHash` to be a primitive type in the JSON string but got " + data['confirmedBasketHash']);
      }
      // validate the optional field `directDebitDetails`
      if (data['directDebitDetails']) {
        // data not null
        _DirectDebitDetails["default"].validateJSON(data['directDebitDetails']);
      }
      // validate the optional field `billingAddress`
      if (data['billingAddress']) {
        // data not null
        _Address["default"].validateJSON(data['billingAddress']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} paymentId
 */
DirectDebit.prototype['paymentId'] = undefined;

/**
 * @member {Number} basketId
 */
DirectDebit.prototype['basketId'] = undefined;

/**
 * @member {Number} amount
 */
DirectDebit.prototype['amount'] = undefined;

/**
 * @member {String} currency
 */
DirectDebit.prototype['currency'] = undefined;

/**
 * @member {String} gateway
 */
DirectDebit.prototype['gateway'] = undefined;

/**
 * @member {String} confirmedBasketHash
 */
DirectDebit.prototype['confirmedBasketHash'] = undefined;

/**
 * @member {module:model/DirectDebitDetails} directDebitDetails
 */
DirectDebit.prototype['directDebitDetails'] = undefined;

/**
 * @member {module:model/Address} billingAddress
 */
DirectDebit.prototype['billingAddress'] = undefined;
var _default = exports["default"] = DirectDebit;